import { navigateTo as navigate } from '#app'
import { useAppointmentStore } from '~/terminierungsportal/stores/appointment'

export const useRouterNavigation = () => {
  const appointmentStore = useAppointmentStore()

  const navigateTo = (routeName: string) => {
    return navigate({
      name: routeName,
      params: {
        appointmentId: appointmentStore.appointmentId
      }
    })
  }

  return { navigateTo }
}
